var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.096 19.5093C32.096 25.6817 27.1497 30.6855 21.048 30.6855C14.9464 30.6855 10 25.6817 10 19.5093C10 13.3368 14.9464 8.33301 21.048 8.33301C27.1497 8.33301 32.096 13.3368 32.096 19.5093Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4281 19.5093C46.4281 25.6817 41.4817 30.6855 35.38 30.6855C29.2784 30.6855 24.332 25.6817 24.332 19.5093C24.332 13.3368 29.2784 8.33301 35.38 8.33301C41.4817 8.33301 46.4281 13.3368 46.4281 19.5093Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.214 28.0162C30.5896 25.9662 32.096 22.9159 32.096 19.5096C32.096 16.1033 30.5896 13.0529 28.214 11.0029C25.8384 13.0529 24.332 16.1033 24.332 19.5096C24.332 22.9159 25.8384 25.9662 28.214 28.0162Z",
    fill: "#6C6BBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "var(--input-border)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.2fb09b476321ae0c0edac58c0112d57c.svg";
export { ForwardRef as ReactComponent };